
































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import Ajax from '../../../lib/ajax'
import {FieldType,Filter,CompareType} from '../../../store/entities/filter'
import PageRequest from '../../../store/entities/page-request'
import CreateUser from './create-user.vue'
import EditUser from './edit-user.vue'
@Component({
    name:'user',
    components:{CreateUser,EditUser}
})
export default class Users extends AbpBase{
    edit(){
        this.editModalShow=true;
    }
    filters:Filter[]=[
        {Type:FieldType.String,Value:'',FieldName:'UserName',CompareType:CompareType.Contains},
        {Type:FieldType.String,Value:'',FieldName:'FullName',CompareType:CompareType.Contains},
        {Type:FieldType.DataRange,Value:'',FieldName:'CreationTime',CompareType:CompareType.Contains},
        {Type:FieldType.Boolean,Value:null,FieldName:'IsActive',CompareType:CompareType.Equal}
    ]
    searchData:any = {
        BelongOrgId:null,
        RoleId:null
    };
    orgs:any = {};
    roles:any={};
    createModalShow:boolean=false;
    editModalShow:boolean=false;
    get list(){
        return this.$store.state.user.list;
    };
    get loading(){
        return this.$store.state.user.loading;
    }
    // get resetPassword(){
    //     return this['$store'].state.user.resetPassword;
    // }
    create(){
        this.createModalShow=true;
    }
    isActiveChange(val:string){
        if(val==='Actived'){
            this.searchData.IsActive=true;
        }else if(val==='NoActive'){
            this.searchData.IsActive=false;
        }else{
            this.searchData.IsActive=null;
        }
    }
    pageChange(page:number){
        //this.$store.commit('user/setCurrentPage',page);
        this.searchData.SkipCount = page-1;
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        //this.$store.commit('user/setPageSize',pagesize);
        this.searchData.MaxResultCount = pagesize;
        this.getpage();
    }
    async getpage(){
        // let where= Util.buildFilters(this.filters);
        // let pagerequest=new PageRequest();
        // pagerequest.maxResultCount=this.pageSize;
        // pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
        // pagerequest.where=where;
        await this.$store.dispatch({
            type: 'user/getAll',
            data: this.searchData
        })
    }
    get pageSize(){
        return this.$store.state.user.pageSize;
    }
    get totalCount(){
        return this.$store.state.user.totalCount;
    }
    get currentPage(){
        return this.$store.state.user.currentPage;
    }
    async GetAllOrganization(){
        await Ajax.get("/api/services/app/Organization/GetAllOrganizationAsync").then( (res:any)=>{
            this.orgs = res.data.result;
        } );
    }
    async GetAllRoles(){
         await Ajax.get("/api/services/app/Role/GetAllNotPagingAsync").then( (res:any)=>{
            this.roles = res.data.result;
        } );
    }
    columns=[
    {
        title: '用户名',
        key:'userName'
    },
    {
        title: '姓名',
        key:'name'
    },
    {
        title: '部门',
        key:'belongOrganizationName'
    },
    {
        title: '二级部门',
        key:'secondOrganizationName'
    },
    {
        title: '职(务)位',
        key:'place'
    },
    {
        title: '是否激活',
        render:(h:any,params:any)=>{
           return h('span',params.row.isActive? '是': '否')
        }
    },
    {
        title: '锁定时间',
        // key:"lockoutEndDateUtc"
        render:((h:any,params:any)=>{
            if(params.row['lockoutEndDateUtc'] == null) return h('span',"无"); else return h('span',new Date(params.row['lockoutEndDateUtc']).toLocaleString());
        })
    },
    {
        title: '创建时间',
        key:'creationTime',
        render:(h:any,params:any)=>{
            return h('span',new Date(params.row.creationTime).toLocaleDateString())
        }
    },
    {
        title: '最后登录时间',
        render:(h:any,params:any)=>{
            console.log(params.row.lastLoginTime)
            let lastLoginTime = !!params.row.lastLoginTime?new Date(params.row.lastLoginTime).toLocaleString():'';
            return h('span',lastLoginTime)
        }
    },
    {
        title: '操作',
        key:'Actions',
        width:240,
        render:(h:any,params:any)=>{
            return h('div',[
                h('Button',{
                    props:{
                        type:'primary',
                        size:'small'
                    },
                    style:{
                        marginRight:'5px'
                    },
                    on:{
                        click:async ()=>{
                            console.log(params.row)
                            this.$store.commit('user/edit',params.row);
                            if(params.row.belongUnitId != null){
                                await this['$store'].dispatch({
                                    type:"user/getOneOrg",
                                    data:params.row.belongUnitId,
                                })
                            }
                            this.edit();
                        }
                    }
                }, '编辑'),
                h('Button',{
                    props:{
                        type:'error',
                        size:'small'
                    },
                    style:{
                        marginRight:'5px'
                    },
                    on:{
                        click:async ()=>{
                            this.$Modal.confirm({
                                    title: '提示',
                                    content: '确认删除此用户？',
                                    okText: '确认',
                                    cancelText: '取消',
                                    onOk:async()=>{
                                        await this.$store.dispatch({
                                            type:'user/delete',
                                            data:params.row
                                        })
                                        await this.getpage();
                                    }
                            })
                        }
                    }
                }, '删除'),
                h('Button',{
                    props:{
                        type:'warning',
                        size:'small'
                    },
                    style:{
                        marginRight:'5px'
                    },
                    on:{
                        click:()=>{
                            this.$Modal.confirm({
                                title: '提示',
                                content: '确认重置该用户的密码？',
                                onOk: async () => {
                                    Ajax.post('/api/services/app/User/ResetPasswordAsync',params.row).then( (res:any)=>{
                                        setTimeout(() => {
                                            this['$Modal'].success({
                                                title: "重置密码成功，成功后的密码为：",
                                                content: res.data.result
                                            });
                                        }, 500);
                                        
                                    });
                                }
                            });
                        }
                    }
                }, '重置密码'),
                h('Button',{
                    props:{
                        type:'primary',
                        size:'small',
                    },
                    style:{
                        display:params.row['lockoutEndDateUtc'] != null?'':'none'
                    },
                    on:{
                        click:()=>{
                            this['$Modal'].confirm({
                                title: '提示',
                                content: '是否解锁该用户？',
                                onOk: async () => {
                                    await this['$store'].dispatch({
                                        type:'user/unlock',
                                        data:params.row
                                    })
                                    this['$Message'].success('解锁成功!');
                                    await this.getpage();
                                }
                            });
                        }
                    }
                }, '解锁')
            ])
        }
    }
    ]
    async created(){
        await this.GetAllOrganization();
        await this.GetAllRoles();
        this.getpage();
        await this.$store.dispatch({
            type:'user/getRoles'
        })
    }
}
